module.exports = __webpack_public_path__ + "img/Image4.5da66444.png";